import { render } from "./FaqTable.vue?vue&type=template&id=1bc52f76"
import script from "./FaqTable.vue?vue&type=script&lang=js"
export * from "./FaqTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__